export default "__VITE_ASSET__BhUJdWTb__"